import React, { useEffect, useState } from "react";
import styles from './LandingPage.module.css';

const CreatorBanner = (props) => {

    return (
        <section className={styles.creatorBanner}>
            <div className={styles.landingContainer}>
                <div className={styles.bannerBox}>
                    <div className={styles.bannerImg}>
                        <img
                            src="https://admin.rebeltv.me/rebel-homepage-assets/creator.png"
                            alt=""
                        />
                    </div>

                    <div className={styles.bannerText}>
                        <h2>
                            JOIN FOR FREE AND <br />
                            <span className={styles.colorPink}>CREATE CONTENT</span>
                        </h2>

                        <p>
                            Creating content in Rebel is free and fun with many ways to
                            monetize: Video, Image, Live, Audio, Stories and more.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CreatorBanner;